import { render, staticRenderFns } from "./SoMessage.vue?vue&type=template&id=34af7440&scoped=true&"
import script from "./SoMessage.vue?vue&type=script&lang=js&"
export * from "./SoMessage.vue?vue&type=script&lang=js&"
import style0 from "./SoMessage.vue?vue&type=style&index=0&id=34af7440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af7440",
  null
  
)

export default component.exports